import { useProfile } from '@/ContextTab/modules/user/composables/useProfile'
import { useColorsStore } from '@/ContextTab/stores/colors'
import { usePublishedNewsStore } from '@/ContextTab/stores/newsSet/published/published'
import type { SetProfileColorData } from '../types'


export function useColorMap() {

  const colorsStore = useColorsStore()
  const publishedNewsStore = usePublishedNewsStore()

  const { updateColors: updateProfileColors } = useProfile({})

  async function setColors(items: SetProfileColorData) {
    await updateProfileColors(items)
    colorsStore.setNewsCodesColorMap(publishedNewsStore.set)
  }

  return { setColors }
}
